//Types
export var FORGOT_PASSWORD_RESET_ACTION_TYPE = "forgot_password/reset";
export var FORGOT_PASSWORD_SEND_START_ACTION_TYPE = "forgot_password/send_start";
export var FORGOT_PASSWORD_SEND_SUCCESS_ACTION_TYPE = "forgot_password/send_success";
export var FORGOT_PASSWORD_UNKNOWN_EMAIL_ACTION_TYPE = "forgot_password/unknown_email";
export var FORGOT_PASSWORD_ERROR_ACTION_TYPE = "forgot_password/error";
